// extracted by mini-css-extract-plugin
export var sliderRange = "_on-2";
export var sliderRoot = "_on-0";
export var sliderThumb = "_on-3";
export var sliderTrack = "_on-1";